import { render, staticRenderFns } from "./GroupDialog.vue?vue&type=template&id=27a21d34"
import script from "./GroupDialog.vue?vue&type=script&lang=ts"
export * from "./GroupDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports